import { impexDateFormat } from "../manager/dateManager";

export const PURCHASE_ORDER_COLUMN = [
  {
    Header: "SUPPLIER",
    accessor: "Supplier",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. DATE",
    accessor: "PODate",
    show: true,
    exportable: true,
  },
  {
    Header: "DUE DATE",
    accessor: "duedate",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. TYPE",
    accessor: "POType",
    show: false,
    exportable: true,
  },
  {
    Header: "PAYMENT TERMS",
    accessor: "PaymentTerms",
    show: false,
    exportable: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
    exportable: true,
  },
  {
    Header: "QUANTITY",
    accessor: "QTY",
    show: true,
    exportable: true,
  },
  {
    Header: "PENDING QTY.",
    accessor: "PendingQTY",
    show: true,
    exportable: true,
  },
  {
    Header: "DELIVERY TERMS",
    accessor: "DeliveryTerms",
    show: false,
    exportable: true,
  },
  {
    Header: "STATUS",
    accessor: "LatestAction",
    show: true,
    exportable: true,
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    show: false,
    exportable: true,
  },
];

export const FORECAST_ORDER_COLUMN = [
  {
    Header: "COMPANY NAME",
    accessor: "CompanyName",
    show: false,
    exportable: true,
  },
  {
    Header: "SUPPLIER NAME",
    accessor: "SupplierName",
    show: true,
    exportable: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
    exportable: true,
  },
  {
    Header: "PART DESCRIPTION",
    accessor: "PartDescription",
    show: false,
    exportable: true,
  },
  {
    Header: "DUE DATE",
    accessor: "DueDate",
    show: true,
    exportable: true,
  },
  {
    Header: "SUPPLIER DUE DATE",
    accessor: "SupplierDueDate",
    show: false,
    exportable: true,
  },
  {
    Header: "IMPEX PO. NUMBER",
    accessor: "PONumber",
    show: true,
    exportable: true,
  },
  {
    Header: "ORDER TYPE",
    accessor: "OrderType",
    show: true,
    exportable: true,
  },
  {
    Header: "TRANSIT TIME",
    accessor: "TransitTime",
    show: false,
    exportable: true,
  },
  {
    Header: "SHIP TO LOCATION",
    accessor: "ShipToLocation",
    show: true,
    exportable: true,
  },
  {
    Header: "PRICE",
    accessor: "Price",
    show: true,
    exportable: true,
  },
  {
    Header: "CURRENCY",
    accessor: "Currency",
    show: false,
    exportable: true,
  },
  {
    Header: "ORDERED QTY.",
    accessor: "QTYOrdered",
    show: false,
    exportable: true,
  },
  {
    Header: "PO. QTY.",
    accessor: "POQTY",
    show: false,
    exportable: true,
  },
  {
    Header: "SHIPPED QTY.",
    accessor: "ShippedQty",
    show: false,
    exportable: true,
  },
  {
    Header: "IN HAND QTY.",
    accessor: "InHandQTY",
    show: false,
    exportable: true,
  },
  {
    Header: "REJECTED QTY.",
    accessor: "RejectedQTY",
    show: false,
    exportable: true,
  },
  {
    Header: "PENDING QTY.",
    accessor: "PendingQTY",
    show: false,
    exportable: true,
  },
  {
    Header: "SHORTAGE QTY.",
    accessor: "ShortageQTY",
    show: false,
    exportable: true,
  },
  {
    Header: "HSN",
    accessor: "HSN",
    show: false,
    exportable: true,
  },
];

export const GRN_ORDER_COLUMN = [
  {
    Header: "CUSTOMER NAME",
    accessor: "CustomerName",
    show: true,
    exportable: false,
  },
  {
    Header: "SUPPLIER NAME",
    accessor: "SupplierName",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
    exportable: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
    exportable: true,
  },
  {
    Header: "RECEIPT NUMBER",
    accessor: "ReceiptNo",
    show: true,
    exportable: true,
  },
  {
    Header: "SUPPLIER INVOICE NUMBER",
    accessor: "SupplierInvoiceNo",
    show: false,
    exportable: true,
  },
  {
    Header: "SUPPLIER INVOICE DATE",
    accessor: "SupplierInvoiceDate",
    show: false,
    exportable: true,
  },
  {
    Header: "TOTAL PACKAGE COUNT",
    accessor: "TotalPackageCount",
    show: false,
    exportable: true,
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    show: false,
    exportable: false,
  },
  {
    Header: "DRIVER NAME",
    accessor: "DriverName",
    show: false,
    exportable: false,
  },
  {
    Header: "DRIVER CONTACT NO.",
    accessor: "DriverContactNo",
    show: false,
    exportable: false,
  },
  {
    Header: "VEHICEL TYPE",
    accessor: "VehicleType",
    show: false,
    exportable: false,
  },
  {
    Header: "VEHICEL NUMBER",
    accessor: "VehicleNo",
    show: false,
  },
  {
    Header: "PICKUP POINT",
    accessor: "PickUpPoint",
    show: false,
    exportable: false,
  },
  {
    Header: "LR NO.",
    accessor: "LRNo",
    show: false,
    exportable: false,
  },
  {
    Header: "LR DATE",
    accessor: "LRDate",
    show: false,
    exportable: false,
  },
  {
    Header: "RECEIPT DATE",
    accessor: "ReceiptDate",
    show: true,
    exportable: true,
  },
  {
    Header: "MODIFIED DATE",
    accessor: "ModifiedDate",
    show: false,
    exportable: false,
  },
  {
    Header: "RECEIPT AMOUNT",
    accessor: "InvoiceAmount",
    show: false,
    exportable: false,
  },
  {
    Header: "EXCISE",
    accessor: "Excise",
    show: false,
    exportable: false,
  },
  {
    Header: "TCS",
    accessor: "TCS",
    show: false,
    exportable: false,
  },
  {
    Header: "END CESS",
    accessor: "EdCess",
    show: false,
    exportable: false,
  },
  {
    Header: "HEAD CESS",
    accessor: "HedCess",
    show: false,
    exportable: false,
  },
  {
    Header: "VAR %",
    accessor: "VatPercent",
    show: false,
    exportable: false,
  },
  {
    Header: "VAT AMOUNT",
    accessor: "VatAmount",
    show: false,
    exportable: false,
  },
  {
    Header: "FINAL INVOICE AMOUNT",
    accessor: "FinalInvoiceAmount",
    show: false,
    exportable: false,
  },
  {
    Header: "QC DATE TIME",
    accessor: "QCDateTime",
    show: false,
    exportable: true,
  },
  {
    Header: "QC REMARKS",
    accessor: "QCRemarks",
    show: true,
    exportable: true,
  },
  {
    Header: "QC PERFORMED BY",
    accessor: "QCPerformedBy",
    show: false,
    exportable: false,
  },
  {
    Header: "RECEIVED QTY.",
    accessor: "ReceivedQty",
    show: false,
    exportable: true,
  },
  {
    Header: "PART PRICE",
    accessor: "PartPrice",
    show: false,
    exportable: false,
  },
  {
    Header: "ACCEPTED QTY.",
    accessor: "AcceptedQty",
    show: true,
    exportable: true,
  },
  {
    Header: "REJECTED QTY.",
    accessor: "RejectedQty",
    show: false,
    exportable: true,
  },
  {
    Header: "IS ATA",
    accessor: "IsATA",
    show: false,
    exportable: false,
  },
  {
    Header: "SAC CODE",
    accessor: "SAC_Code",
    show: false,
    exportable: false,
  },
  {
    Header: "DELIVERY TERM",
    accessor: "DeliveryTerm",
    show: false,
    exportable: false,
  },
  {
    Header: "MATHADI CHARGES",
    accessor: "MathadiCharges",
    show: false,
    exportable: false,
  },
  {
    Header: "TRANSPORTATION CHARGES",
    accessor: "TransportationCharges",
    show: false,
    exportable: false,
  },
  {
    Header: "MATHADI DATE",
    accessor: "MathadiDate",
    show: false,
    exportable: false,
  },
  {
    Header: "MATHADI RECEIPT NO.",
    accessor: "MathadiReceiptNo",
    show: false,
    exportable: false,
  },
  {
    Header: "VIEW GRN",
    accessor: "view",
    show: true,
    exportable: false,
  },
];

export const INVOICE_COLUMN = [
  {
    Header: "SUPPLIER NAME",
    accessor: "Supplier",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. DATE",
    accessor: "PODate",
    show: true,
    exportable: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
    exportable: true,
  },
  {
    Header: "DUE DATE",
    accessor: "duedate",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. TYPE",
    accessor: "POType",
    show: false,
    exportable: true,
  },
  {
    Header: "PAYMENT TERMS",
    accessor: "PaymentTerms",
    show: false,
    exportable: true,
  },
  {
    Header: "QUANTITY",
    accessor: "QTY",
    show: true,
    exportable: true,
  },
  {
    Header: "DELIVERY TERMS",
    accessor: "DeliveryTerms",
    show: false,
    exportable: true,
  },
  {
    Header: "STATUS",
    accessor: "LatestAction",
    show: true,
    exportable: true,
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    show: false,
    exportable: true,
  },
  
];

export const GENERATED_INVOICE_COLUMN = [
  {
    Header: "INVOICE NUMBER",
    accessor: "InvoiceNo",
    show: true,
    exportable: true,
  },
  {
    Header: "SUPPLIER NAME",
    accessor: "Supplier",
    show: true,
    exportable: true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
    exportable: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
    exportable: true,
  },
  {
    Header: "QUANTITY",
    accessor: "PartQty",
    show: true,
    exportable: true,
  },
  {
    Header: "UPLOADED QUANTITY",
    accessor: "UploadedQty",
    show: true,
    exportable: true,
  },
  {
    Header: "INVOICE AMOUNT",
    accessor: "InvoiceAmount",
    show: false,
    exportable: true,
  },
  {
    Header: "CARGO READY DATE",
    accessor: "CargoReadyDate",
    show: true,
    exportable: true,
    Cell: ({ row }) => {
      return impexDateFormat(row.original.CargoReadyDate);
    },
  },
  {
    Header: "CARGO DELAYED DATE",
    accessor: "CargoDelayedDate",
    show: true,
    exportable: true,
    Cell: ({ row }) => {
      return impexDateFormat(row.original.CargoDelayedDate);
    },
  },
  {
    Header: "CREATED DATE",
    accessor: "CreatedDate",
    show: true,
    exportable: true,
    Cell: ({ row }) => {
      return impexDateFormat(row.original.CreatedDate);
    },
  },
];

export const INVOICE_FOR_DOC_COLUMNS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "QTY.",
    accessor: "Qty",
    show: true,
  },
  {
    Header: "RATE / UNIT",
    accessor: "RatePerUnit",
    show: true,
  },
  {
    Header: "IN-TRANSIT QTY",
    accessor: "InTransitQty",
    show: true,
  },
  {
    Header: "RECE QTY.",
    accessor: "ReceivedQty",
    show: true,
  },
  {
    Header: "BAL. QTY.",
    accessor: "bal_qty",
    show: true,
  },
];

export const PO_PART_DETAILS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "QTY",
    accessor: "Qty",
    show: true,
  },
  {
    Header: "PENDING QTY",
    accessor: "Pending Qty",
    show: true,
  },
  {
    Header: "RATE",
    accessor: "RatePerUnit",
    show: true,
  },
];

export const GRN_DETAILS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "PO QTY",
    accessor: "POQty",
    show: true,
  },
  {
    Header: "INVOICE QTY",
    accessor: "InvoiceQty",
    show: true,
  },
  {
    Header: "TOTAL AMOUNT",
    accessor: "TotalAmount",
    show: true,
  },
];

export const QC_DETAILS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "REJECTED QTY",
    accessor: "RejectedQty",
    show: true,
  },
  {
    Header: "MAIN REASON",
    accessor: "MainReason",
    show: true,
  },
  {
    Header: "REASON",
    accessor: "Reason",
    show: true,
  },
];

export const QC_REJECTED_COLUMNS = [
  {
    Header: "SUPPLIER NAME",
    accessor: "Supplier",
    show: true,
  },
  {
    Header: "PO. NUMBER",
    accessor: "PONumber",
    show: true,
  },
  {
    Header: "PART NUMBER",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "RECEIPT NUMBER",
    accessor: "ReceiptNo",
    show: true,
  },
  {
    Header: "RECEIPT DATE",
    accessor: "ReceiptDate",
    show: true,
  },
  {
    Header: "QC STATUS",
    accessor: "QCStatus",
    show: true,
  },
  {
    Header: "RECEIVED QTY.",
    accessor: "ReceiptQty",
    show: false,
  },
  {
    Header: "ACCEPTED QTY.",
    accessor: "AcceptedQty",
    show: true,
  },
  {
    Header: "QC DATE",
    accessor: "QCStatusDate",
    show: true,
  },
  {
    Header: "REJECTED QTY.",
    accessor: "RejectedQty",
    show: true,
  },
  {
    Header: "MAIN REASON",
    accessor: "MainReason",
    show: true,
  },
  {
    Header: "REASON",
    accessor: "Reason",
    show: true,
  },
];

export const PO_UPDATE_COLUMNS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "QTY",
    accessor: "Qty",
    show: true,
  },
  {
    Header: "DUE DATE",
    accessor: "DueDate",
    show: true,
  },
];

export const PO_REVISED_COLUMNS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "REVISED QTY",
    accessor: "NewQty",
    show: true,
  },
  {
    Header: "REVISED DUE DATE",
    accessor: "NewDueDate",
    show: true,
    Cell: ({ row }) => {
      return impexDateFormat(row.original.NewDueDate);
    },
  },
  {
    Header: "REQUESTED DATE",
    accessor: "CreatedDate",
    show: true,
    Cell: ({ row }) => {
      return impexDateFormat(row.original.CreatedDate);
    },
  },
  {
    Header: "REQUESTED BY",
    accessor: "CreatedBy",
    show: true,
  },
  {
    Header: "STATUS",
    accessor: "Status",
    show: true,
  },
];

export const PRICE_REVISED_COLUMNS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "REVISED PRICE",
    accessor: "NewPrice",
    show: true,
  },
  {
    Header: "REQUESTED DATE",
    accessor: "CreatedDate",
    show: true,
    Cell: ({ row }) => {
      return impexDateFormat(row.original.CreatedDate);
    },
  },
  {
    Header: "REQUESTED BY",
    accessor: "CreatedBy",
    show: true,
  },
  {
    Header: "STATUS",
    accessor: "Status",
    show: true,
  },
];

export const PO_PRICE_UPDATE_COLUMNS = [
  {
    Header: "PART NO.",
    accessor: "PartNo",
    show: true,
  },
  {
    Header: "RATE PER UNIT",
    accessor: "RatePerUnit",
    show: true,
  },
];
  export const INVOICE_NUMBER_UPDATE = [
    {
      Header: "Existing invoice number",
      accessor: "Invoicenumber",
      show: true,
    },
    {
      Header: "New invoice number",
      accessor: "newinvoicenumber",
      show: true,
    },
];
